import { Component, OnInit } from '@angular/core';
import { Session } from '../objects/Session';
import { Globals } from '../objects/Globals';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  session:Session
  constructor(private globals:Globals) { }

  ngOnInit() {
    this.session = this.globals.Session.Session;
  }

}
